import { formatDateString } from "@cp/toolkit";
import { PolicyState } from "@qw/graphql";
import { ExpiredPolicyState } from "@qw/ui";
import { PRODUCTION_APP_ORIGINS } from "@/constants/app-origins";
import { useInboxInsured } from "@/providers/use-inbox-insured";
import { Row } from "../components/row";
import { Section, SectionHeader } from "../components/section";

const now = Date.now();

export const ActivePolicies = () => {
  const { activePolicies, insuredId } = useInboxInsured();
  return (
    <Section>
      <SectionHeader count={activePolicies.length}>Active Policies</SectionHeader>
      {activePolicies.map((policy) => {
        const { id, appetiteProduct, effectiveDate, expirationDate, policyNumber, state } = policy;
        const expired = Date.parse(expirationDate) < now;
        return (
          <Row
            key={id}
            href={`${PRODUCTION_APP_ORIGINS.brokerage}/insured/${insuredId}/policies/${id}`}
            state={expired && state === PolicyState.Issued ? ExpiredPolicyState.Expired : state}
          >
            <div className="flex-1 space-y-1.5 truncate">
              <div className="font-medium truncate">{appetiteProduct.carrierName}</div>
              <div className="text-muted-foreground truncate">{appetiteProduct.carrierProductName}</div>
            </div>
            <div className="flex-1 space-y-1.5 truncate">
              <div className="font-medium truncate">{policyNumber}</div>
              <div className="text-muted-foreground truncate">Eff {formatDateString(effectiveDate, "MMM d, yyyy")}</div>
            </div>
            <div className="w-4" />
          </Row>
        );
      })}
    </Section>
  );
};
